import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3009/api/v1';

export interface UserAuditEventDTO {
  id: number;
  eventType: string;
  actorUserId: number | null;
  targetUserId: number | null;
  siteId: number | null;
  cameraId: number | null;
  recordingId: number | null;
  alarmHistoryId: number | null;
  durationSeconds: number | null;
  success: boolean | null;
  reason: string | null;
  ipAddress: string | null;
  userAgent: string | null;
  payload: Record<string, unknown> | null;
  occurredAt: string;
  actorEmail: string | null;
  actorUsername: string | null;
}

export interface ListUserAuditEventsResult {
  rows: UserAuditEventDTO[];
  total: number;
  page: number;
  pageSize: number;
}

function unwrapData<T>(body: unknown): T | undefined {
  if (body == null || typeof body !== 'object') return undefined;
  const b = body as Record<string, unknown>;
  if ('data' in b && b.data !== undefined) return b.data as T;
  return body as T;
}

export const userAuditApi = {
  list: async (params: {
    from?: string;
    to?: string;
    eventType?: string;
    actorUserId?: number;
    page?: number;
    pageSize?: number;
  }): Promise<ListUserAuditEventsResult> => {
    const { data } = await axios.get(`${API_URL}/rbac/user-audit-events`, { params });
    const payload = unwrapData<ListUserAuditEventsResult>(data);
    if (!payload || !Array.isArray(payload.rows)) {
      return { rows: [], total: 0, page: 1, pageSize: 25 };
    }
    return payload;
  }
};
